<template>
  <v-dialog v-model="dialog" width="600px" persistent>
    <v-card>
      <v-card-title class="d-flex justify-space-between py-3 px-6">
        {{ popupTitle }}
        <v-btn icon @click="closePopup">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 py-3">
        <v-form ref="form">
          <BaseInput
            isRequiredTitle
            :label="formLabel"
            :placeholder="formPlaceholder"
            v-model="title"
            :rules="[$rules.required]"
          />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="px-6 py-3">
        <BaseButton text="Hủy" outlined @click="closePopup" />
        <v-spacer />
        <BaseButton text="Lưu" @click="onSubmit" :loading="loading" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapActions} from 'vuex'
import BaseButton from '../../../../components/basic/BaseButton.vue'
import BaseInput from '../../../../components/basic/BaseInput.vue'
export default {
  components: {BaseInput, BaseButton},
  props: {
    popupTitle: String,
    formLabel: String,
    formPlaceholder: String,
    messageSuccess: String,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      title: '',
      id: '',
    }
  },
  methods: {
    ...mapActions({
      updateMark: 'gradeMark/update',
    }),
    openPopup({title, id}) {
      this.title = title
      this.id = id
      this.dialog = true
    },
    closePopup() {
      this.dialog = false
      this.refresh()
    },
    refresh() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async onSubmit() {
      if (!this.$refs['form'].validate()) return
      this.loading = true
      try {
        await this.updateMark({id: this.id, title: this.title})
        this.$emit('onRefresh')
        this.$alert.success(this.messageSuccess)
        this.loading = false
        this.closePopup()
      } catch (error) {
        this.loading = false
        this.$alert.error(error)
      }
    },
  },
}
</script>
